import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';

const HeaderBottomIsLogin = () => (
  <nav
    class="navbar fixed-bottom bg-body-tertiary"
    style="--bs-navbar-padding-y:0;"
  >
    <div class={style.navbarBottomItems}>
      <Item href="/redirect/cart" icon="fa-shopping-cart" />
      <Item href="/redirect/dashboard" icon="fa-tachometer" />
      <Item href="/profile" icon="fa-user" />
    </div>
  </nav>
);

const Item = props => {
  return (
    <Link
      href={props.href}
      activeClassName="active"
      class={`navbar-bottom-item text-center ${style.navbarBottomItem}`}
    >
      <i class={`fa ${props.icon} fa-2x`} aria-hidden="true" />

      <span />
    </Link>
  );
};

export default HeaderBottomIsLogin;
